import * as React from 'react'
import { GlobalContext } from 'components/Store'
import MarkerIcon from 'components/map/MarkerIcon'
import clsx from 'clsx'

export default function ProjectsLegend({ projectTypes }) {
	const { $filteredType, set$filteredType } = React.useContext(GlobalContext)

	const groupedProjectTypes = projectTypes.reduce((acc, type) => {
		if (!acc[type.category]) acc[type.category] = []
		acc[type.category].push(type)
		return acc
	}, {})

	return (
		<div className="space-y-3">
			{Object.entries(groupedProjectTypes)?.map(([category, types], i) => (
				<dl
					className="flex gap-x-3 gap-y-2 text-sm md:items-center <md:flex-col"
					key={i}
				>
					<dt className="technical shrink-0 font-bold <md:text-xs">
						{category}:
					</dt>

					<dd className="flex flex-wrap items-start gap-2">
						{types?.map((type, ii) => (
							<button
								className={clsx(
									'with-icon gap-0 rounded-full border border-l-0 bg-[var(--bg)]',
									$filteredType === type.name
										? 'border-white'
										: 'border-transparent',
								)}
								style={{
									'--bg': `${type.color}${$filteredType === type.name ? '66' : '22'}`,
								}}
								onClick={() => {
									if ($filteredType === type.name) set$filteredType(null)
									else set$filteredType(type.name)
								}}
								key={ii}
							>
								<MarkerIcon type={type} />
								<div className="relative pl-2 pr-3">{type.name}</div>
							</button>
						))}
					</dd>
				</dl>
			))}
		</div>
	)
}
